import React from 'react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import Select from '../../../components/Form/Select';
import { OutTransactionFormData, DropdownOption } from './outTransactionTypes';

interface OutPaymentMethodSectionProps {
  register: UseFormRegister<OutTransactionFormData>;
  errors: FieldErrors<OutTransactionFormData>;
  bankOptions: DropdownOption[];
  safeOptions: DropdownOption[];
  branchOptions: DropdownOption[];
  amountToType: 'bank' | 'safe';
  isMoneyIn: boolean;
  banksLoading: boolean;
  safesLoading: boolean;
  branchesLoading: boolean;
}

const OutPaymentMethodSection: React.FC<OutPaymentMethodSectionProps> = ({
  register,
  errors,
  bankOptions,
  safeOptions,
  branchOptions,
  amountToType,
  isMoneyIn,
  banksLoading,
  safesLoading,
  branchesLoading,
}) => {
  return (
    <div className="bg-gray-50 rounded-xl p-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
        <svg className="w-5 h-5 mr-2 text-ocean-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
        </svg>
        Amount To
      </h3>

      <div className="space-y-6">
        <div className="flex items-center">
          <input
            type="checkbox"
            id="moneyIn"
            {...register('moneyIn')}
            className="h-4 w-4 text-ocean-600 focus:ring-ocean-500 border-gray-300 rounded"
          />
          <label htmlFor="moneyIn" className="ml-2 block text-sm text-gray-900">
            Money In (Simple transaction)
          </label>
        </div>

        <div className="space-y-4">
          <label className="block text-sm font-semibold text-gray-700">
            Amount To Type
            <span className="text-red-500 ml-1">*</span>
          </label>
          <div className="flex space-x-6">
            <div className="flex items-center">
              <input
                type="radio"
                id="amountToBank"
                value="bank"
                {...register('amountToType', { required: 'Amount to type is required' })}
                className="h-4 w-4 text-ocean-600 focus:ring-ocean-500 border-gray-300"
              />
              <label htmlFor="amountToBank" className="ml-2 text-sm text-gray-900">
                Bank Account
              </label>
            </div>
            <div className="flex items-center">
              <input
                type="radio"
                id="amountToSafe"
                value="safe"
                {...register('amountToType', { required: 'Amount to type is required' })}
                className="h-4 w-4 text-ocean-600 focus:ring-ocean-500 border-gray-300"
              />
              <label htmlFor="amountToSafe" className="ml-2 text-sm text-gray-900">
                Safe Box
              </label>
            </div>
          </div>
          {errors.amountToType && (
            <p className="text-sm text-red-600">{errors.amountToType.message}</p>
          )}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {amountToType === 'bank' && (
            <Select
              label="Bank Account"
              options={bankOptions}
              placeholder={banksLoading ? "Loading banks..." : "Select a bank account"}
              required
              {...register('bankId', { required: amountToType === 'bank' ? 'Bank account is required' : false })}
              error={errors.bankId?.message}
            />
          )}

          {amountToType === 'safe' && (
            <Select
              label="Safe Box"
              options={safeOptions}
              placeholder={safesLoading ? "Loading safes..." : "Select a safe box"}
              required
              {...register('safeId', { required: amountToType === 'safe' ? 'Safe box is required' : false })}
              error={errors.safeId?.message}
            />
          )}

          {isMoneyIn && (
            <Select
              label="Vessel / Headquarters"
              options={branchOptions}
              placeholder={branchesLoading ? "Loading branches..." : "Select vessel or headquarters"}
              required
              {...register('branchId', { required: isMoneyIn ? 'Vessel/Headquarters is required for Money In transactions' : false })}
              error={errors.branchId?.message}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default OutPaymentMethodSection;
